import { PropMappingType } from "./type";
export function normalizePropToEventMapping(tagName, propName, propMapping) {
    return {
        mappingType: PropMappingType.Event,
        event: {
            name: `${propMapping.event.noTagName ? "" : tagName + "--"}${propMapping.event.name}`,
            description: propMapping.event.description,
            options: propMapping.event.options,
        },
        tagName,
        propName,
    };
}
const DEFAULT_OPTIONS = {
    description: "",
    noTagName: false,
    bubbles: true,
    cancelable: true,
    composed: true,
};
export function asEventEmitter(eventName, options) {
    const opts = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    return {
        mappingType: PropMappingType.Event,
        event: {
            name: eventName,
            description: opts.description,
            noTagName: opts.noTagName,
            options: {
                bubbles: opts.bubbles,
                cancelable: opts.cancelable,
                composed: opts.composed,
            },
        },
    };
}
